module.exports = __webpack_public_path__ + "img/cook.67d0324f.webp";